import React from 'react';

const Checkbox = ({user, handleSelectAdmin, recipients}) => {
  const isChecked = () => {
    return recipients.some((recipient) => {
      if (typeof recipient === 'string') {
        return recipient === user.email;
      } else if (recipient && typeof recipient === 'object') {
        return recipient.email === user.email && recipient.articleId === user.articleId;
      }
      return false;
    })
  }

  const authorLabel = () => {
    if (!user.hasOwnProperty('isSubmittingAuthor')) {
      return ''
    } else if (user.isSubmittingAuthor) {
      return <strong>(Submitting Author)</strong>
    } else {
      return <strong>(Coauthor)</strong>
    }
  }

  return (
    <div className="checkbox">
      <label>
        <input type="checkbox" checked={isChecked()} onChange={handleSelectAdmin} value={JSON.stringify(user)} />
        &nbsp;{user.email}&nbsp;{authorLabel()}
      </label>
    </div>
  )
}

export default Checkbox